import React from 'react';
import '../../assets/styles/support-email.sass';

const SupportEmail = () => {
  const supportEmail = 'support@gocurb.com';
  const onClickHandler = e => {
    const { href, target } = e.target || {};
    e.preventDefault();
    window.open(href, target ? target : '_self');
  };
  return (
    <div className="support-container">
      <div className="support">
        <span className="support-text">Feedback? </span>
        <a
          href={`mailto:${supportEmail}`}
          target="_blank"
          rel="noopener noreferrer"
          className="support-email"
          onClick={onClickHandler}
        >
          {supportEmail}
        </a>
      </div>
    </div>
  );
};

export default SupportEmail;
